import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "options-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_circle_loader = _resolveComponent("circle-loader")!
  const _component_LoanOption = _resolveComponent("LoanOption")!
  const _component_next_button = _resolveComponent("next-button")!
  const _component_step = _resolveComponent("step")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, null, {
    default: _withCtx(() => [
      (_ctx.loading || _ctx.gettingRatePlans)
        ? (_openBlock(), _createBlock(_component_circle_loader, {
            key: 0,
            inline: true
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_step, null, {
        header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Which Option Fits Your Needs?", -1)
        ]))]),
        actions: _withCtx(() => [
          (_ctx.ratePlansExist)
            ? (_openBlock(), _createBlock(_component_next_button, {
                key: 0,
                loading: _ctx.loading,
                disabled: _ctx.loading || _ctx.selectedPaymentOption === undefined,
                onClick: _ctx.goBackToPortal,
                text: "Save Changes"
              }, null, 8, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appRatePlans, (option, index) => {
              return (_openBlock(), _createBlock(_component_LoanOption, {
                key: index,
                ratePlan: option,
                schoolSelected: _ctx.schoolSelected,
                requestedAmount: _ctx.requestedAmount,
                onToggleRepayments: ($event: any) => (option.paymentOptionsActive = !option.paymentOptionsActive),
                "onUpdate:repaymentType": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatePaymentOption($event)))
              }, null, 8, ["ratePlan", "schoolSelected", "requestedAmount", "onToggleRepayments"]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.ratePlansExist]
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.loading && !_ctx.gettingRatePlans]
      ])
    ]),
    _: 1
  }))
}